import { render, staticRenderFns } from "./OffersLayout.vue?vue&type=template&id=f9640a26&scoped=true&"
import script from "./OffersLayout.vue?vue&type=script&lang=js&"
export * from "./OffersLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9640a26",
  null
  
)

export default component.exports